export enum Operation {
  BR = 'BR',
  MZ = 'MZ',
}
